var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 82 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6804 82.0313C51.7077 82.0313 53.8073 79.3946 55.3698 75.3906L80.1745 10.5957C80.9558 8.64263 81.3952 6.88482 81.3952 5.41992C81.3952 2.68552 79.6862 0.976624 77.0007 0.976624C75.5359 0.976624 73.778 1.46483 71.8249 2.19733L6.59052 27.2461C3.1726 28.5156 0.389404 30.6641 0.389404 33.7402C0.389404 37.5977 3.41674 38.8672 7.27412 39.9902L26.7566 45.9473C29.4909 46.7773 30.907 46.7773 32.7624 45.0684L75.0964 5.76173C75.6335 5.27343 76.2683 5.37112 76.6589 5.71292C77.0984 6.10352 77.1472 6.78713 76.6589 7.32423L37.5476 49.8535C35.9362 51.6113 35.7898 52.9297 36.6687 55.8105L42.3327 74.7559C43.5046 78.8086 44.7741 82.0313 48.6804 82.0313Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b7d4bbbbf3f1b945333da281b8a1a137.svg";
export { ForwardRef as ReactComponent };